import { TrackingService } from '@x/common/tracking/tracking.service';

export function initializeTracking(trackingService: TrackingService): Function {
  return (): Promise<boolean[]> => trackingService.initialize();
}

export function logMessageByColor(message: string, color: string = '#32de84') {
  console.debug(`%c${message}`, `color: ${color};`);
}
